module.exports = __webpack_public_path__ + "img/21.6ec1fd56.png";